// Import polyfills.
import "core-js/stable";
import "custom-event-polyfill";
import "event-source-polyfill";
import "process"; // Import the process polyfill


// Import global styles.
import "antd/dist/antd.min.css";
import "@Styles/main.scss";

// Other imports.
import * as React from "react";
import * as ReactDOM from "react-dom";
import SessionManager from "@Core/session";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import { showApplicationLoader, hideApplicationLoader } from "@Utils";
import { getBranding } from "@Branding";
import * as RoutesModule from "./routes";
const routes = RoutesModule.routes;

const setupSession = () => {
    SessionManager.resetSession();
    SessionManager.initSession();
};

const setupGlobalPlugins = () => {
    // Use this function to configure plugins on the client side.
};

const setupEvents = () => {
    showApplicationLoader();
    document.addEventListener("DOMContentLoaded", () => {
        hideApplicationLoader();
    });
};

/**
 * Set up branding-specific variables.
 */
const setupBranding = () => {
    document.documentElement.style.setProperty("--brand-accent", getBranding("--brand-accent"));
};

/**
 * Create browser history.
 */
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

const renderApp = () => {
    // This code starts up the React app when it runs in a browser.
    // It sets up the routing configuration and injects the app into a DOM element.
    ReactDOM.render(<Router history={history} children={routes} />, document.getElementById("react-app"));
};

// Setup the application and render it.
setupSession();
setupGlobalPlugins();
setupEvents();
setupBranding();
renderApp();

if (module.hot) module.hot.accept();
